import React, { Component } from "react";
import { connect } from "react-redux";
import * as dataActions from "../../../../../../_actions/dataActions";
import Wrapper from "../../../../../../_hoc/Wrapper";
import PageSubTitle from "../../../../../UI/PageSubTitle";
import EditWidget from "../../../../../UI/EditWidget";
import Select from "../../../../../UI/Select";
import getFamilyType from "../../../../../../_selectors/dataSelectors/getFamilyType";
import getFamilyValue from "../../../../../../_selectors/dataSelectors/getFamilyValue";
import getFamilyStatus from "../../../../../../_selectors/dataSelectors/getFamilyStatus";
import getEducation from "../../../../../../_selectors/dataSelectors/getEducation";
import getEmployedIn from "../../../../../../_selectors/dataSelectors/getEmployedIn";
import getHouseType from "../../../../../../_selectors/dataSelectors/getHouseType";
import getIncome from "../../../../../../_selectors/dataSelectors/getIncome";

class FamilyDetail extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userProfile) {
      const {
        familyIncome,
        familyMembers,
        familyStatus,
        familyType,
        familyValue,
        brother,
        marriedBrother,
        sister,
        marriedSister,
        fatherEducation,
        fatherService,
        motherEducation,
        motherService,
        houseType
      } = nextProps.userProfile;
      const {
        isEditModeOn,
        selectedFamilyIncome,
        selectedFamilyMembers,
        selectedFamilyStatus,
        selectedFamilyType,
        selectedFamilyValue,
        selectedBrother,
        selectedMarriedBrother,
        selectedSister,
        selectedMarriedSister,
        selectedFatherEducation,
        selectedFatherService,
        selectedMotherEducation,
        selectedMotherService,
        selectedHouseType
      } = prevState;
      if (isEditModeOn) {
        return null;
      } else {
        if (
          familyIncome !== selectedFamilyIncome ||
          familyMembers !== selectedFamilyMembers ||
          familyStatus !== selectedFamilyStatus ||
          familyType !== selectedFamilyType ||
          familyValue !== selectedFamilyValue ||
          brother !== selectedBrother ||
          marriedBrother !== selectedMarriedBrother ||
          sister !== selectedSister ||
          marriedSister !== selectedMarriedSister ||
          fatherEducation !== selectedFatherEducation ||
          fatherService !== selectedFatherService ||
          motherEducation !== selectedMotherEducation ||
          motherService !== selectedMotherService ||
          houseType !== selectedHouseType
        ) {
          return {
            selectedFamilyIncome: familyIncome,
            selectedFamilyMembers: familyMembers,
            selectedFamilyStatus: familyStatus,
            selectedFamilyType: familyType,
            selectedFamilyValue: familyValue,
            selectedBrother: brother,
            selectedMarriedBrother: marriedBrother,
            selectedSister: sister,
            selectedMarriedSister: marriedSister,
            selectedFatherEducation: fatherEducation,
            selectedFatherService: fatherService,
            selectedMotherEducation: motherEducation,
            selectedMotherService: motherService,
            selectedHouseType: houseType
          };
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
  }
  state = {
    isEditModeOn: false,
    showEdit: this.props.showEdit,
    selectedFamilyType: null,
    selectedFamilyStatus: null,
    selectedFamilyValue: null,
    selectedBrother: null,
    selectedMarriedBrother: null,
    selectedSister: null,
    selectedMarriedSister: null,
    selectedFatherEducation: null,
    selectedFatherService: null,
    selectedMotherEducation: null,
    selectedMotherService: null,
    selectedHouseType: null,
    selectedFamilyIncome: null,
    selectedFamilyMembers: null,
    marriedBrotherOptions: [],
    marriedSisterOptions: []
  };
  componentDidMount() {
    const {
      familyStatus,
      familyType,
      familyValue,
      education,
      employedIn,
      houseType,
      income,
      getEducationData,
      getEmployedInData,
      getFamilyStatusData,
      getFamilyTypeData,
      getFamilyValueData,
      getHouseTypeData,
      getIncomeData
    } = this.props;
    if (familyStatus.length === 0) {
      getFamilyStatusData();
    }
    if (familyType.length === 0) {
      getFamilyTypeData();
    }
    if (familyValue.length === 0) {
      getFamilyValueData();
    }
    if (education.length === 0) {
      getEducationData();
    }
    if (employedIn.length === 0) {
      getEmployedInData();
    }
    if (houseType.length === 0) {
      getHouseTypeData();
    }
    if (income.length === 0) {
      getIncomeData();
    }

    let memberOptions = [];
    for (let index = 0; index <= 10; index++) {
      if (index === 0) {
        memberOptions.push({ label: `None`, value: index });
      } else {
        memberOptions.push({ label: `${index}`, value: index });
      }
    }
    this.memberOptions = memberOptions;
  }
  disableEditMode = () => {
    this.setState({ isEditModeOn: false });
  };
  enableEditMode = () => {
    this.setState({ isEditModeOn: true });
  };
  save = () => {
    const {
      selectedBrother,
      selectedFamilyIncome,
      selectedFamilyMembers,
      selectedFamilyStatus,
      selectedFamilyType,
      selectedFamilyValue,
      selectedFatherEducation,
      selectedFatherService,
      selectedHouseType,
      selectedMarriedBrother,
      selectedMarriedSister,
      selectedMotherEducation,
      selectedMotherService,
      selectedSister
    } = this.state;
    const { update, toast } = this.props;
    const updatedFamilyDetail = {
      brother: selectedBrother,
      familyIncome: selectedFamilyIncome,
      familyMembers: selectedFamilyMembers,
      familyStatus: selectedFamilyStatus,
      familyType: selectedFamilyType,
      familyValue: selectedFamilyValue,
      fatherEducation: selectedFatherEducation,
      fatherService: selectedFatherService,
      houseType: selectedHouseType,
      marriedBrother: selectedMarriedBrother,
      marriedSister: selectedMarriedSister,
      motherEducation: selectedMotherEducation,
      motherService: selectedMotherService,
      sister: selectedSister
    };
    const onSuccess = () => {
      this.setState({ isEditModeOn: false });
      toast({ type: "info", message: "Profile Updated" });
    };
    const onError = err => {
      toast({ type: "error", message: err });
    };
    update({ data: updatedFamilyDetail, onSuccess, onError });
  };
  render() {
    const {
      isEditModeOn,
      showEdit,
      selectedBrother,
      selectedFamilyIncome,
      selectedFamilyMembers,
      selectedFamilyStatus,
      selectedFamilyType,
      selectedFamilyValue,
      selectedFatherEducation,
      selectedFatherService,
      selectedHouseType,
      selectedMarriedBrother,
      selectedMotherEducation,
      selectedMotherService,
      selectedMarriedSister,
      selectedSister,
      marriedBrotherOptions,
      marriedSisterOptions
    } = this.state;
    const {
      familyStatus,
      familyType,
      familyValue,
      education,
      employedIn,
      houseType,
      income,
      userProfile
    } = this.props;
    return (
      <Wrapper>
        <PageSubTitle>
          <h3>
            Family Detail
            <EditWidget
              edit={isEditModeOn}
              onEdit={this.enableEditMode}
              onSave={this.save}
              onCancel={this.disableEditMode}
              disabled={userProfile.cache}
              show={showEdit}
            />
          </h3>
          <p />
        </PageSubTitle>
        <div className="form-group-one-unit">
          <div className="row">
            <div className="col-md-4">
              <Select
                label={<Wrapper>Family Type</Wrapper>}
                selected={selectedFamilyType}
                options={familyType}
                onChange={value => {
                  this.setState({ selectedFamilyType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Family Status</Wrapper>}
                selected={selectedFamilyStatus}
                options={familyStatus}
                onChange={value => {
                  this.setState({ selectedFamilyStatus: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Family Values</Wrapper>}
                selected={selectedFamilyValue}
                options={familyValue}
                onChange={value => {
                  this.setState({ selectedFamilyValue: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <Select
                label={<Wrapper>Brother</Wrapper>}
                selected={selectedBrother}
                options={this.memberOptions}
                onChange={value => {
                  let options = [];

                  if (value.value === 0) {
                    options = [];
                  } else {
                    options.push({
                      label: "None",
                      value: 0
                    });
                    for (let index = 1; index <= value.value; index++) {
                      options.push({
                        label: `${index}`,
                        value: index
                      });
                    }
                  }

                  this.setState({
                    selectedBrother: value,
                    marriedBrotherOptions: options,
                    selectedMarriedBrother: null
                  });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-3">
              <Select
                label={<Wrapper>Married</Wrapper>}
                selected={selectedMarriedBrother}
                options={marriedBrotherOptions}
                onChange={value => {
                  this.setState({ selectedMarriedBrother: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn || selectedBrother === null}
              />
            </div>
            <div className="col-md-3">
              <Select
                label={<Wrapper>Sister</Wrapper>}
                selected={selectedSister}
                options={this.memberOptions}
                onChange={value => {
                  let options = [];

                  if (value.value === 0) {
                    options = [];
                  } else {
                    options.push({
                      label: "None",
                      value: 0
                    });
                    for (let index = 1; index <= value.value; index++) {
                      options.push({
                        label: `${index}`,
                        value: index
                      });
                    }
                  }

                  this.setState({
                    selectedSister: value,
                    marriedSisterOptions: options,
                    selectedMarriedSister: null
                  });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-3">
              <Select
                label={<Wrapper>Married</Wrapper>}
                selected={selectedMarriedSister}
                options={marriedSisterOptions}
                onChange={value => {
                  this.setState({ selectedMarriedSister: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn || selectedSister === null}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <Select
                label={<Wrapper>Father Education</Wrapper>}
                selected={selectedFatherEducation}
                options={education}
                onChange={value => {
                  this.setState({ selectedFatherEducation: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-3">
              <Select
                label={<Wrapper>Father Service</Wrapper>}
                selected={selectedFatherService}
                options={employedIn}
                onChange={value => {
                  this.setState({ selectedFatherService: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-3">
              <Select
                label={<Wrapper>Mother Education</Wrapper>}
                selected={selectedMotherEducation}
                options={education}
                onChange={value => {
                  this.setState({ selectedMotherEducation: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-3">
              <Select
                label={<Wrapper>Mother Service</Wrapper>}
                selected={selectedMotherService}
                options={employedIn.concat([
                  { label: "House Wife", value: "houseWife" }
                ])}
                onChange={value => {
                  this.setState({ selectedMotherService: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <Select
                label={<Wrapper>House</Wrapper>}
                selected={selectedHouseType}
                options={houseType}
                onChange={value => {
                  this.setState({ selectedHouseType: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-4">
              <Select
                label={<Wrapper>Family Annual Income</Wrapper>}
                selected={selectedFamilyIncome}
                options={income}
                onChange={value => {
                  this.setState({ selectedFamilyIncome: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
            <div className="col-md-5">
              <Select
                label={<Wrapper>Family Members living together</Wrapper>}
                selected={selectedFamilyMembers}
                options={this.memberOptions}
                onChange={value => {
                  this.setState({ selectedFamilyMembers: value });
                }}
                clearable={false}
                searchable={true}
                placeholder="-"
                readOnly={!isEditModeOn}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  familyType: getFamilyType(state),
  familyValue: getFamilyValue(state),
  familyStatus: getFamilyStatus(state),
  education: getEducation(state),
  employedIn: getEmployedIn(state),
  houseType: getHouseType(state),
  income: getIncome(state)
});

const mapDispatchToProps = dispatch => ({
  getFamilyTypeData: () => dispatch(dataActions.getFamilyType()),
  getFamilyValueData: () => dispatch(dataActions.getFamilyValue()),
  getFamilyStatusData: () => dispatch(dataActions.getFamilyStatus()),
  getEducationData: () => dispatch(dataActions.getEducation()),
  getEmployedInData: () => dispatch(dataActions.getEmployedIn()),
  getHouseTypeData: () => dispatch(dataActions.getHouseType()),
  getIncomeData: () => dispatch(dataActions.getIncome())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FamilyDetail);



// WEBPACK FOOTER //
// ./src/_components/Profile/Home/ProfileInformation/Family/FamilyDetail/index.js